import type { Collection_Collection as CollectionType } from '__generated__/graphql-types-do-not-use';

import type { RelatedRecommendationFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedRelatedRecommendationsEntityFragment';

export const RECOMMENDATIONS_LIMIT = 12;
export type RelatedRecsFragment = RelatedRecommendationFragment[] | undefined;
export type PartialCollectionType = Partial<CollectionType> | undefined;

export const getFormattedRecommendations = (relatedRecs: PartialCollectionType) => {
  const { context, recommenderConfigurationHash, entities } = relatedRecs || {};
  const relatedRecsEntities = entities?.elements as RelatedRecsFragment;
  if (!relatedRecs || !relatedRecsEntities) {
    return undefined;
  }

  const getFormattedProductCardData = (collectionData: RelatedRecommendationFragment) => {
    const { canonicalType, productTypeAttributes } = collectionData;
    let link = '';
    let productType = '';
    let imageUrl = '';

    if (productTypeAttributes?.__typename === 'ProductCard_Course') {
      const { slug, promoPhotoUrl } = productTypeAttributes.canonical;
      link = slug ? `/learn/${slug}` : '';
      productType = canonicalType ?? '';
      imageUrl = promoPhotoUrl ?? '';
    } else if (productTypeAttributes?.__typename === 'ProductCard_Specialization') {
      const { cardImageUrl, urlPath, productVariant } = productTypeAttributes.canonical;
      switch (productVariant) {
        case 'NORMAL_S12N':
          link = urlPath;
          productType = 'SPECIALIZATION';
          imageUrl = cardImageUrl;
          break;

        case 'PROFESSIONAL_CERTIFICATE_S12N':
          link = urlPath;
          productType = 'PROFESSIONAL_CERTIFICATE';
          imageUrl = cardImageUrl;
          break;

        default:
          break;
      }
    }
    return {
      link,
      productType,
      imageUrl,
    };
  };

  const formattedRecommendations = relatedRecsEntities
    .flatMap((collection) => {
      if (!collection) {
        return undefined;
      }

      const attr = collection?.productTypeAttributes ?? {};
      const canonical = 'canonical' in attr ? attr.canonical : undefined;

      return {
        ...getFormattedProductCardData(collection),
        id: collection?.id,
        name: canonical?.name,
        slug: canonical?.slug,
        partners: canonical?.partners,
        recommenderConfigurationHash,
        context,
      };
    })
    .filter((collection) => collection !== undefined);

  return formattedRecommendations as Partial<CollectionType>;
};
